@if (showInitialLoader()) {
	<uc-university-skeleton [header]="false" />
}
@if (
	{
		university: university$ | async,
		ratingStats: universityRatingStats$ | async,
		reviews: universityReviews$ | async,
	};
	as data
) {
	@if (data.university) {
		<main
			ucUniProfileGAEvent
			ucUniImpression
			[eventTypes]="['view']"
			[uniId]="data.university.id"
			[uniName]="data.university.name"
			[ugSearchOrderPosition]="data.university.order"
			[cleSearchOrderPosition]="null"
			product=""
			profileTab="Reviews"
			class="relative sm:mt-0"
		>
			<uc-university-slider
				[uniGallery]="uniGallery"
				[product]="product"
				[isFeaturedGallery]="false"
				[id]="data.university.id"
				[saved]="data.university.saved"
				[delta]="1"
				[ugSearchOrderPosition]="data.university.order"
				[cleSearchOrderPosition]="null"
				[uniName]="data.university.name"
			>
				<div headerTitle class="w-full">
					<uc-university-header-title
						[name]="data.university.name"
						[recommendedPercentage]="
							data.university.stats.recommended_percentage
						"
						[paidFeatures]="data.university.paid_features"
						[subdirectory]="product.toLowerCase()"
						[product]="product"
						[slug]="data.university.slug"
						[uniId]="data.university.id"
					/>
					<div class="border border-red-500">
						<uc-write-review-btn
							data-cy="cta-section-write-review-btn"
							[universityId]="data.university.id"
							[universityUrl]="data.university.slug"
							[universityName]="data.university.name"
							customStyles="block w-full secondary-button only-tab-focus !no-underline"
						/>
					</div>
				</div>

				@if (data.ratingStats) {
					<uc-university-reviews-stats
						class="w-full mt-8 sm:mt-0 md:col-span-2"
						[universityUrl]="universityUrl"
						[universityRatingStats]="data.ratingStats"
						[universityRating]="data.university.stats.rating"
						[totalReviews]="data.university.stats.reviews_count"
						[universityUrl]="universityUrl"
						[uniName]="data.university.name"
						[uniId]="data.university.id"
					/>
				}
			</uc-university-slider>

			<uc-university-reviews-overview
				[ratingStats]="data.ratingStats"
				[totalReviews]="data.university.stats.reviews_count"
			/>
			<!-- Top review -->
			@if (!displaySingleReview() && data.reviews && data.reviews.top) {
				<div class="container">
					<uc-review-card
						[review]="data.reviews.top"
						[topReview]="true"
						[universityName]="data.university.name"
						[universityUrl]="universityUrl"
					/>
				</div>
			}
			<section class="container pt-16 mb-8">
				<h2 class="secondary-header">
					Student Reviews ({{
						displaySingleReview()
							? data.university.stats.reviews_count
							: data.reviews?.total
					}})
				</h2>
				<div class="flex items-center justify-between pb-6">
					<div class="w-4/6">
						<uc-search-bar
							[displayButton]="false"
							[keyword]="searchTerm()"
							customStyles="py-2"
						/>
					</div>
					<uc-sort
						customStyles="right-0 left-auto w-48 sm:w-auto"
						[sortOptions]="sortOptions"
					/>
				</div>
			</section>
			<!-- other reviews -->
			@if (showContentLoader()) {
				<uc-university-skeleton [header]="true" [banner]="false" />
			}
			<div class="container pb-8 sm:pb-16">
				<!-- loop through all reviews-->
				@if (!displaySingleReview() && canLoadMore()) {
					@for (review of data.reviews?.data; track review.id) {
						<uc-review-card
							[review]="review"
							[topReview]="false"
							[universityName]="data.university.name"
							[universityUrl]="universityUrl"
						/>
					}
					@if (data.reviews?.data?.length === 0) {
						<uc-no-result
							[message]="
								getNoReviewsMessage(
									data.university.stats.reviews_count,
									data.university.name
								)
							"
						>
							@if (data.university.stats.reviews_count <= 1) {
								<p>
									<uc-write-review-btn
										[universityId]="data.university.id"
										[universityName]="data.university.name"
										[universityUrl]="universityUrl"
										buttonText="Leave a review"
									/>
								</p>
							}
						</uc-no-result>
					}
				}
				@if (displaySingleReview()) {
					<uc-review-card
						[review]="singleReview"
						[topReview]="false"
						[universityName]="data.university.name"
						[universityUrl]="universityUrl"
					/>
				}

				<!-- load more -->
				@if (data.reviews?.has_more_pages && canLoadMore()) {
					<div class="mt-8">
						<uc-load-more-btn [isLoading]="isLoadMore()" [page]="page" />
					</div>
				}
			</div>
		</main>
		<uc-client-profile-sticky-lead-bar-mobile
			[isFeatured]="false"
			[showWriteReviewButton]="true"
			[uniId]="data.university.id"
			[uniName]="data.university.name"
			[uniSlug]="data.university.slug"
		/>
	}
}
